import { AbstractControl } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

export function fieldMatchValidator(control: AbstractControl, field: FormlyFieldConfig,
  options?: { [id: string]: any; }) {
  const value1 = control.value[options.field1];
  const value2 = control.value[options.field2];

  if (!value1 || !value2) {
    return null;
  }
  if (value2 === value1) {
    return null;
  }
  return { fieldMatch: { message: 'Hasła się nie zgadzają' } };
}
